import { createFileRoute, redirect } from "@tanstack/react-router";

/** Flows are listed as a group on the Questionnaires tab; this path is only a breadcrumb. */
export const Route = createFileRoute("/catalog/flows/")({
  beforeLoad: () => {
    throw redirect({ to: "/catalog/questionnaires" });
  },
});
